import {Property} from '@stitches/react/types/css';

export const selfAssessButtonWidth: Property.Width = 44;
